import { z } from "zod";
import { email, flag, nullableText } from "./common";

const contactFields = {
  firstName: z.string().trim().max(120).optional(),
  lastName: z.string().trim().max(120).optional(),
  email: email.nullable().optional(),
  phone: z.string().trim().max(40).nullable().optional(),
  companyName: z.string().trim().max(200).nullable().optional(),
  title: z.string().trim().max(120).nullable().optional(),
  address: nullableText.optional(),
  smsConsent: flag.optional(),
  emailOptOut: flag.optional(),
  dnc: flag.optional(),
  notes: nullableText.optional(),
};
/** Raw-record checks reuse primitives without applying creation defaults. */
export const contactRecord = z.object(contactFields);
export const contactInput = contactRecord.extend({
  firstName: contactFields.firstName.default(""),
  lastName: contactFields.lastName.default(""),
});
export type ContactInput = z.infer<typeof contactInput>;

// PATCH must not blank the name when only a flag is sent: partial() keeps `.default("")`, so drop the defaults.
export const contactPatch = contactRecord;
export type ContactPatch = z.infer<typeof contactPatch>;

export const contactSearchQuery = z.object({ q: z.string().trim().default(""), limit: z.coerce.number().int().min(1).max(100).default(20) });
